import { Link } from 'react-router-dom';
import { latestComics } from '@/mocks/comics';

export default function LatestSection() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            最近<strong>更新</strong>
          </h2>
          <p className="text-sm text-foreground-500">追踪您喜爱漫画的最新章节</p>
        </div>
        <Link
          to="/category/yuzhou-manhua"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          查看全部
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </div>
        </Link>
      </div>
      <div className="space-y-3">
        {latestComics.slice(0, 6).map((comic, index) => (
          <Link
            key={comic.id}
            to={`/comic/${comic.id}`}
            className="flex items-center gap-4 p-4 rounded-lg hover:bg-background-100 transition-colors cursor-pointer group"
          >
            <span className="text-sm font-bold text-foreground-300 w-5 text-center">
              {String(index + 1).padStart(2, '0')}
            </span>
            <img
              src={comic.coverImage}
              alt={`${comic.title} 星球漫画`}
              title={comic.title}
              className="w-12 h-16 rounded object-cover object-top flex-shrink-0"
            />
            <div className="flex-1 min-w-0">
              <h3 className="font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors truncate">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">
                {comic.author} · {comic.chapters[0]?.title}
              </p>
            </div>
            <div className="flex items-center gap-3">
              <span className={`text-[10px] px-2 py-0.5 rounded-full whitespace-nowrap ${
                comic.status === '连载中' ? 'bg-accent-100 text-accent-700' : 'bg-background-200 text-foreground-600'
              }`}>
                {comic.status}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{comic.updateDate}</span>
              <div className="w-4 h-4 flex items-center justify-center text-foreground-300">
                <i className="ri-arrow-right-s-line"></i>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}